import React from 'react';
import PropTypes from 'prop-types';
import { IconWarning } from '@sm/wds-icons';
import { Card, Button, Typography, Container } from '@sm/wds-react';
import { t } from '@sm/intl';
import COPY from './Copy';

import './error-card.scss';

const ErrorCard = ({
  iconOnly,
  iconOptions,
  copyOptions,
  errorCopy,
  refreshCopy,
  refetch,
  ...otherProps
}) => {
  const Icon = <IconWarning {...iconOptions} />;
  const getErrorMessage = () => {
    if (!errorCopy) {
      return refetch ? t(COPY.troubleLoading) : t(COPY.weSlippedError);
    }

    return errorCopy;
  };

  return (
    <Choose>
      <When condition={iconOnly}>
        <div
          className="wds-flex wds-p-3 wds-flex--x-center wds-type--hero-2"
          data-testid="ErrorCard"
          {...otherProps}
        >
          {Icon}
        </div>
      </When>
      <Otherwise>
        <Card className="sm-error-card" data-testid="ErrorCard">
          <Container flex flexJustify="center" {...otherProps}>
            <Container flex flexAlign="center" mr={3}>
              {Icon}
            </Container>
            <Container flex flexAlign="center">
              <Typography {...copyOptions}>{getErrorMessage()}</Typography>
            </Container>
            <If condition={refetch}>
              <Container flex flexAlign="center">
                <Button
                  className="sm-error-card__refresh-btn"
                  variant="text"
                  size="sm"
                  onClick={() => refetch()}
                >
                  <Typography
                    className="sm-error-card__refresh-text"
                    color="link"
                    {...copyOptions}
                  >
                    {refreshCopy}
                  </Typography>
                </Button>
              </Container>
            </If>
          </Container>
        </Card>
      </Otherwise>
    </Choose>
  );
};

ErrorCard.propTypes = {
  iconOnly: PropTypes.bool,
  iconOptions: PropTypes.shape({
    color: PropTypes.string,
    size: PropTypes.oneOf(['lg', 'md', 'sm', 'xl']),
  }),
  refetch: PropTypes.func,
  copyOptions: PropTypes.shape({
    variant: PropTypes.string,
  }),
  errorCopy: PropTypes.string,
  refreshCopy: PropTypes.string,
};
ErrorCard.defaultProps = {
  iconOnly: false,
  iconOptions: {
    color: null,
    size: 'lg',
  },
  refetch: undefined,
  copyOptions: {
    variant: 'sectionTitle',
  },
  errorCopy: '',
  refreshCopy: t(COPY.refresh),
};
export default ErrorCard;
